import React from 'react'
import { Navbar, Footer, Newsbar } from '../../components';
import { AboutUs, Team } from "./"
import { ContactUs } from "../Contact/"

export default function About() {
  return (
    <div className='emas__about'>
      <Navbar />
      <AboutUs />
      <Team />
      <ContactUs />
      <Newsbar />
      <Footer />
    </div>
  )
}
